import { Resource } from "react-admin";

const Stock = (
    <Resource key="stock"
              name="stock"
    />
);

export default Stock;
